import PropTypes from 'prop-types';

import { isValid, parseISO } from 'date-fns';

import { trans } from '@spotahome/soyuz/client';
import { formatLongReadableDate } from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';

const moveDatesExists = (moveIn, moveOut) => moveIn !== '' && moveOut !== '';

const MinimumStay = ({
  minStayValid = true,
  maxStayValid = true,
  isMoveInDateValid = true,
  moveInDatesRanges = [],
  moveIn = '',
  moveOut = '',
  minStay = 30,
  maxStay = 0
}) => {
  const renderMinimumStayMessage = () => {
    let message = '';

    if (!minStayValid) {
      message += trans('book_now_card.minimum_stay', {
        days: minStay
      });
    } else if (!maxStayValid) {
      message += trans('book_now_card.maximum_stay', {
        days: maxStay
      });
    }

    return (
      <span key="minimum-stay" className="minimum-stay">
        {message}
      </span>
    );
  };

  const renderMoveInDateMessage = () => {
    const and = trans('book_now_card.separator.and');
    const or = trans('book_now_card.separator.or');
    const on = trans('book_now_card.separator.on');
    const after = trans('book_now_card.separator.after');
    const before = trans('book_now_card.separator.before');
    const between = trans('book_now_card.separator.between');

    const ranges = [];
    let content = null;

    const formatRange = (rFrom, rTo, index) => {
      const isMinValid = isValid(parseISO(rFrom));
      const isMaxValid = isValid(parseISO(rTo));
      const moveInMin = formatLongReadableDate(rFrom);
      const moveInMax = formatLongReadableDate(rTo);
      let rangeMessage = null;

      if (!isMinValid) {
        rangeMessage = (
          <span key={index}>
            {before} <i>{moveInMax}</i>
          </span>
        );
      }

      if (!isMaxValid) {
        rangeMessage = (
          <span key={index}>
            {after} <i>{moveInMin}</i>
          </span>
        );
      }

      if (isMinValid && isMaxValid) {
        rangeMessage = (
          <span key={index}>
            {between} <i>{moveInMin}</i> {and} <i>{moveInMax}</i>
          </span>
        );

        if (moveInMin === moveInMax) {
          rangeMessage = (
            <span key={index}>
              {on} <i>{moveInMin}</i>
            </span>
          );
        }
      }

      return rangeMessage;
    };

    moveInDatesRanges.forEach((range, index) => {
      const isNotLast = index < moveInDatesRanges.length - 1;

      ranges.push(formatRange(range.from, range.to, index));
      if (isNotLast) {
        ranges.push(<span key={`${range.from}-${range.to}`}> {or} </span>);
      }
    });

    if (moveInDatesRanges.length > 0) {
      content = (
        <span key="gap-invalid">
          {trans('book_now_card.message.move_in_date_invalid')} {ranges}
        </span>
      );
    }

    return content;
  };

  const content = [];

  if (moveDatesExists(moveIn, moveOut)) {
    content.push(renderMinimumStayMessage());
  }
  if (!isMoveInDateValid) {
    content.push(renderMoveInDateMessage());
  }

  return <div>{content}</div>;
};

MinimumStay.propTypes = {
  minStayValid: PropTypes.bool,
  maxStayValid: PropTypes.bool,
  isMoveInDateValid: PropTypes.bool,
  moveInDatesRanges: PropTypes.array,
  moveIn: PropTypes.string,
  moveOut: PropTypes.string,
  minStay: PropTypes.number,
  maxStay: PropTypes.number
};

export default MinimumStay;
